import { useEffect } from 'react';
import useSessionManager from '../hooks/useSessionManager';

/**
 * Custom hook that automatically validates session for any component
 * Usage: Add `useSessionValidation();` at the top of any component
 */
export const useSessionValidation = () => {
    const { validateSession } = useSessionManager();
    
    useEffect(() => {
        validateSession();
    }, [validateSession]);
};

/**
 * Higher-order function that adds session validation to any component
 * Usage: export default withSessionValidation(YourComponent);
 */
export const withSessionValidation = (WrappedComponent) => {
    return function SessionValidatedComponent(props) {
        useSessionValidation();
        return <WrappedComponent {...props} />;
    };
};